import utils from "../../utils/utils";

let apiURL = ''
// console.log(process.env.NODE_ENV)
if (process.env.NODE_ENV === "development") {
  // alert("开发环境");
  apiURL = 'http://proxy.jiankanghao.net:50087'
  // apiURL = 'https://gaea.haiweikexin.com/api/v1/'
}else {
  // alert("生产环境");
  apiURL = utils.decrypt(document.querySelector("html").getAttribute("family_ba_url"))
}

export default apiURL;
